module.exports = __webpack_public_path__ + "static/media/Profile_4.4c1fd3e9.svg";